
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { WriteInventoryStateDto, InventoryActionModule_all, InventoryBaseState, InventoryKindModule_all, InventoryBaseStateModule_allowedFor, InventoryStatesDto_$reflection, InventoryAction_$reflection, InventoryKind_$reflection, InventoryBaseState_$reflection, InventoryStateDefinition_$reflection } from "../../../Shared/InventoryStates.js";
import { class_type, option_type, bool_type, record_type, list_type, string_type, union_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../../Shared/Shared.js";
import { contains, filter } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { safeHash, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

export class DialogMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Create", "Edit"];
    }
}

export function DialogMode_$reflection() {
    return union_type("Settings.InventoryStates.Types.DialogMode", [], DialogMode, () => [[], [["Item", InventoryStateDefinition_$reflection()]]]);
}

export class Form extends Record {
    constructor(Mode, Name, Description, Color, BaseState, AppliesTo, AllowedActions) {
        super();
        this.Mode = Mode;
        this.Name = Name;
        this.Description = Description;
        this.Color = Color;
        this.BaseState = BaseState;
        this.AppliesTo = AppliesTo;
        this.AllowedActions = AllowedActions;
    }
}

export function Form_$reflection() {
    return record_type("Settings.InventoryStates.Types.Form", [], Form, () => [["Mode", DialogMode_$reflection()], ["Name", string_type], ["Description", string_type], ["Color", string_type], ["BaseState", InventoryBaseState_$reflection()], ["AppliesTo", list_type(InventoryKind_$reflection())], ["AllowedActions", list_type(InventoryAction_$reflection())]]);
}

export class State extends Record {
    constructor(States, LoadFailed, Form, PendingDelete, FormState) {
        super();
        this.States = States;
        this.LoadFailed = LoadFailed;
        this.Form = Form;
        this.PendingDelete = PendingDelete;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.InventoryStates.Types.State", [], State, () => [["States", RequestedValue$1_$reflection(InventoryStatesDto_$reflection())], ["LoadFailed", bool_type], ["Form", option_type(Form_$reflection())], ["PendingDelete", option_type(InventoryStateDefinition_$reflection())], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StatesFetched", "Reload", "OpenCreate", "OpenEdit", "CloseDialog", "SetName", "SetDescription", "SetColor", "SetBaseState", "SetKind", "SetAction", "SetAllActions", "Save", "Saved", "MoveUp", "MoveDown", "Reordered", "SetArchived", "ArchivedChanged", "OpenDelete", "CloseDelete", "Delete", "Deleted", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.InventoryStates.Types.Msg", [], Msg, () => [[["Item", InventoryStatesDto_$reflection()]], [], [], [["Item", InventoryStateDefinition_$reflection()]], [], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", InventoryBaseState_$reflection()]], [["Item1", InventoryKind_$reflection()], ["Item2", bool_type]], [["Item1", InventoryAction_$reflection()], ["Item2", bool_type]], [["Item", bool_type]], [], [["Item", ClientApiResponse$1_$reflection(InventoryStateDefinition_$reflection())]], [["Item", string_type]], [["Item", string_type]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item1", string_type], ["Item2", bool_type]], [["Item1", bool_type], ["Item2", ClientApiResponse$1_$reflection(string_type)]], [["Item", InventoryStateDefinition_$reflection()]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

export function FormModule_kindsFor(baseState) {
    return filter((kind) => contains(baseState, InventoryBaseStateModule_allowedFor(kind), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), InventoryKindModule_all);
}

export const FormModule_empty = new Form(new DialogMode(0, []), "", "", "#2563eb", new InventoryBaseState(0, []), InventoryKindModule_all, InventoryActionModule_all);

export function FormModule_ofDefinition(definition) {
    return new Form(new DialogMode(1, [definition]), definition.Name, definition.Description, definition.Color, definition.BaseState, definition.AppliesTo, definition.AllowedActions);
}

export function FormModule_toDto(form) {
    return new WriteInventoryStateDto(form.Name, form.Description, form.Color, form.BaseState, form.AppliesTo, form.AllowedActions);
}

export function FormModule_current(form) {
    const matchValue = form.Mode;
    if (matchValue.tag === 1) {
        return matchValue.fields[0];
    }
    else {
        return undefined;
    }
}

export function FormModule_isSystem(form) {
    return defaultArg(map((_arg) => _arg.IsSystem, FormModule_current(form)), false);
}

